import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';

import VeeValidate from 'vee-validate';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Authentication } from './components/Authentication';

Vue.use(VeeValidate, /*{
  aria: false,
}*/);

Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(fas, far, fab);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('body');

document.title = 'motch';
